import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "apInputTel__inner" }
const _hoisted_2 = {
  key: 0,
  class: "apInputTel__label"
}
const _hoisted_3 = { class: "apInputTel__field" }
const _hoisted_4 = ["value", "disabled"]
const _hoisted_5 = { class: "apInputTel__icon" }
const _hoisted_6 = {
  key: 0,
  class: "apInputTel__hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_operator_icon = _resolveComponent("operator-icon")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['apInputTel', {'apInputTel--error': _ctx.hasErrorText}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "apInputTel__code" }, "+7", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "apInputTel__input",
          type: "tel",
          value: _ctx.modelValue,
          disabled: _ctx.disabled,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args)))
        }, null, 40, _hoisted_4), [
          [_directive_mask, '### ### ## ##']
        ]),
        _createElementVNode("span", _hoisted_5, [
          _withDirectives(_createVNode(_component_operator_icon, { name: _ctx.iconName }, null, 8, ["name"]), [
            [_vShow, _ctx.iconName]
          ])
        ])
      ]),
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_ctx.hintOrError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.hintOrError), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ], 2))
}